module.exports = __webpack_public_path__ + "static/media/vsCode.0261db2f.png";